import React, { useState } from "react";
import { SuccessModal } from "../../components/modal";

export default function EditProfile() {
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    username: "",
    bioInformation: "",
    socialMedia: "",
    profilePicture: "",
  });

  function handleChange(ev) {
    const { name, value, type, files } = ev.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "file" ? files[0] : value,
    }));
  }

  // Success Modal
  function handleSubmit(ev) {
    ev.preventDefault();
    setIsSuccessModalOpen(true);
  }

  const closeSuccessModal = () => setIsSuccessModalOpen(false);

  return (
    <>
      <div className="p-6 bg-white rounded-lg shadow-md m-3">
        <h2 className="text-purple font-satoshi text-20 font-bold mb-6">
          My Profile
        </h2>
        <div className="w-[60%] mt-10">
          <form onSubmit={handleSubmit}>
            <div className="flex justify-between gap-8 mb-8">
              <InputField
                label="First Name"
                name="firstName"
                onChange={handleChange}
                value={formData.firstName}
              />
              <InputField
                label="Last Name"
                name="lastName"
                onChange={handleChange}
                value={formData.lastName}
              />
            </div>
            <div className="mb-8">
              <InputField
                label="Email"
                name="email"
                onChange={handleChange}
                value={formData.email}
              />
            </div>
            <div className="flex justify-between gap-8 mb-8">
              <InputField
                label="Phone number"
                name="phoneNumber"
                onChange={handleChange}
                value={formData.phoneNumber}
              />
              <InputField
                label="Username "
                name="username"
                onChange={handleChange}
                value={formData.username}
              />
            </div>
            <div className="mb-8">
              <TextField
                label="Bio Information"
                name="bioInformation"
                onChange={handleChange}
                value={formData.bioInformation}
              />
            </div>
            <div className="mb-8">
              <FileInputField
                label="Change Picture Profile"
                name="profilePicture"
                onChange={handleChange}
              />
            </div>
            <div className="text-left">
              <button
                type="submit"
                className="bg-purple text-white px-5 py-3 rounded-full font-semibold"
              >
                Update Profile
              </button>
            </div>
            {/* Success Modal */}
            <SuccessModal
              isOpen={isSuccessModalOpen}
              onClose={closeSuccessModal}
            />
          </form>
        </div>
      </div>
    </>
  );
}

function InputField({ label, name, value, onChange }) {
  return (
    <>
      <div className="flex flex-col gap-2 w-full">
        <label className="block text-[#400167] font-medium text-16 font-Satoshi">
          {label}
        </label>
        <input
          type="text"
          name={name}
          placeholder={name}
          value={value}
          onChange={onChange}
          className="w-full border-[1.5px] border-[#400167] outline-none px-4 py-3 rounded-md focus:ring-2 focus:ring-[#400167]"
        />
      </div>
    </>
  );
}

function TextField({ label, name, value, onChange }) {
  return (
    <>
      <div className="flex flex-col gap-2 w-full">
        <label className="block text-[#400167] font-medium text-16 font-Satoshi">
          {label}
        </label>
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          rows="4"
          placeholder="Name"
          className="w-full px-4 py-2  border-[1.5px] border-[#400167] rounded-md focus:outline-none focus:ring-2 focus:ring-[#400167]"
        ></textarea>
      </div>
    </>
  );
}

function FileInputField({ label, name, onChange }) {
  return (
    <div className="flex flex-col gap-2 w-full">
      <label className="block text-[#400167] font-medium text-16 font-Satoshi">
        {label}
      </label>
      <input
        type="file"
        name={name}
        onChange={onChange}
        className="w-full px-4 py-2  border-[1.5px] border-[#400167] rounded-md focus:outline-none focus:ring-2 focus:ring-[#400167]"
      />
    </div>
  );
}
